"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _set2 = _interopRequireDefault(require("lodash/set"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactButton = _interopRequireDefault(require("@nerdwallet/react-button"));

var _impression = require("@nerdwallet/analytics/react/impression");

var _authFlowButtonModule = _interopRequireDefault(require("./auth-flow-button.module.less"));

var _openers = _interopRequireDefault(require("./openers"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Helper component that wraps children in a button component for accessibility.
 */
var NoAppearanceButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    _react["default"].createElement("button", _extends({
      className: _authFlowButtonModule["default"]['no-appearance-button']
    }, props, {
      ref: ref
    }))
  );
});

NoAppearanceButton.displayName = 'NoAppearanceButton';
/**
 * Button that when clicked opens an Auth Dialog with the desired flow.
 * Renders as a NW Button component unless indicated not to.
 * All non-named props (e.g. children) are passed down to the button.
 *
 * @return {func} component
 */

var AuthFlowButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var flowPreset = props.flowPreset,
      flowProps = props.flowProps,
      hideButtonAppearance = props.hideButtonAppearance,
      onClick = props.onClick,
      ctaLabel = props.ctaLabel,
      buttonProps = _objectWithoutProperties(props, ["flowPreset", "flowProps", "hideButtonAppearance", "onClick", "ctaLabel"]); // Deprecation warning for old flows


  if (process.env.CONFIG_ENV === 'development' && flowPreset === 'basic') {
    /* eslint-disable no-console */
    console.warn('basic flow is deprecated. Use onboardingGeneric or another flow.');
    /* eslint-enable no-console */
  }

  var ButtonComponent = hideButtonAppearance ? NoAppearanceButton : _reactButton["default"];

  var regOnClick = function regOnClick(e) {
    var flowPropsWithAuth = flowProps || {}; // If an authType is not explicitly passed in, set the authType based on the
    // hasSuccessfullyOnboarded localStorage flag

    if (!flowPropsWithAuth.authType) {
      var hasSuccessfullyOnboarded = (0, _get2["default"])(window, 'localStorage') && window.localStorage.getItem('hasSuccessfullyOnboarded');
      flowPropsWithAuth.authType = hasSuccessfullyOnboarded ? 'signin' : 'register';
    } // Opener


    (0, _get2["default"])(_openers["default"], flowPreset, function () {})(flowPropsWithAuth); // User's requested onClick

    onClick(e);
  };

  return /*#__PURE__*/_react["default"].createElement(ButtonComponent, _extends({
    onClick: regOnClick,
    primary: !hideButtonAppearance
  }, buttonProps, {
    ref: ref
  }));
});

AuthFlowButton.displayName = 'AuthFlowButton';
AuthFlowButton.defaultProps = {
  onClick: function onClick() {}
};
AuthFlowButton.propTypes = {
  /** Desired auth flow. */
  flowPreset: _propTypes["default"].oneOf(_toConsumableArray(Object.keys(_openers["default"]))).isRequired,

  /** Optional cta_label override prop */
  ctaLabel: _propTypes["default"].string,

  /**
   * Uses a button with no appearance instead of Primary Button.
   */
  hideButtonAppearance: _propTypes["default"].bool,

  /**
   * Optional params passed to showAuthDialog.
   * See https://github.com/NerdWallet/nw-auth-dialog/wiki/Beta:-new-onboarding-flows
   */
  flowProps: _propTypes["default"].shape({
    /** Custom flow configuration for NW Auth Dialog. */
    flowConfig: _propTypes["default"].shape({
      createGoal: _propTypes["default"].shape({
        goal_type: _propTypes["default"].string,
        goal_subtype: _propTypes["default"].string
      })
    }),

    /**
     * Tracking params for NW Auth Dialog.
     * See https://github.com/NerdWallet/nw-auth-dialog/wiki/Examples
     */
    trk: _propTypes["default"].shape({
      trk_copy: _propTypes["default"].string,
      navigation_source_impression_id: _propTypes["default"].string
    }),

    /**
     * Changes the authType of the NW Auth Dialog.
     * This flag controls whether the user will initially see the sign in or register step.
     */
    authType: _propTypes["default"].oneOf(['register', 'signin']),

    /**
     * Overrides the callback when the modal is successfully completed
     */
    onSuccess: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].bool]),

    /**
     * Entity name for the bedrock impression event
     */
    entityName: _propTypes["default"].string
  }),

  /** Function to be fired along with reg modal opener. */
  onClick: _propTypes["default"].func
};

var AuthFlowButtonWithTracking = function AuthFlowButtonWithTracking(props) {
  var flowPreset = props.flowPreset,
      authType = props.authType,
      ctaLabel = props.ctaLabel,
      entityName = props.entityName;

  var ctaRef = _react["default"].useRef();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1]; // Extracts the text of the button after it's rendered to use when firing `registration_cta_impression` event


  (0, _react.useEffect)(function () {
    var _ctaRef$current;

    setLabel(ctaRef === null || ctaRef === void 0 ? void 0 : (_ctaRef$current = ctaRef.current) === null || _ctaRef$current === void 0 ? void 0 : _ctaRef$current.innerText);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  [ctaRef.current]);
  return /*#__PURE__*/_react["default"].createElement(_impression.Impression, {
    eventType: "registration_cta_impression",
    entityName: entityName || 'auth_flow_button',
    payload: {
      additional_attributes: {
        target_flow: flowPreset,
        cta_mode: 'modal',
        auth_type: authType,
        cta_format: 'button',
        cta_label: ctaLabel || label
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_impression.ImpressionContext.Consumer, null, function (_ref) {
    var impressionId = _ref.impressionId;
    var newProps = (0, _cloneDeep2["default"])(props);
    (0, _set2["default"])(newProps, 'flowProps.trk.navigation_source_impression_id', impressionId);
    return /*#__PURE__*/_react["default"].createElement(AuthFlowButton, _extends({}, newProps, {
      ref: ctaRef
    }));
  }));
};

AuthFlowButtonWithTracking.propTypes = AuthFlowButton.propTypes;
AuthFlowButtonWithTracking.defaultProps = AuthFlowButton.defaultProps;
var _default = AuthFlowButtonWithTracking;
exports["default"] = _default;